function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.788 11.438c0 2.99 1.626 6.997 4.832 11.912a69.82 69.82 0 004.709 6.38c.007.01.016.017.024.026.02.02.039.042.06.062l.053.051.022.02.017.013c.06.05.124.096.19.135l.01.004c.063.037.13.067.197.093.012.004.023.01.035.013.067.024.136.042.206.055l.042.007c.073.011.146.019.219.019h.008c.068-.001.136-.008.204-.018.017-.003.034-.005.05-.009.069-.013.135-.03.2-.053l.043-.016c.064-.025.127-.054.187-.088l.016-.008c.066-.038.128-.083.187-.133l.02-.013c.008-.007.015-.016.024-.023l.05-.047.062-.066.023-.024c.096-.114 2.385-2.82 4.708-6.38 3.207-4.915 4.832-8.923 4.832-11.912 0-5.872-4.762-10.65-10.615-10.65C5.55.788.788 5.566.788 11.438z",
  fill: "#06c",
  fillRule: "evenodd",
  stroke: "#00a1b0",
  strokeWidth: 1.576
});

var SvgMapMarker = function SvgMapMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.806,
    height: 31.016,
    viewBox: "0 0 22.806 31.016",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMapMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-marker.dba5b2c4.svg";
export { ForwardRef as ReactComponent };